import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _RetroactiveEmployee } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { EmployeeBonusEditor } from "../EmployeeBonus/Editors/EmployeeBonus.Editor";
import { AccountEditor } from "../../../editor/AccountEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { InputDate } from "../../../theme/Input/InputDate";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { BasicButton } from "../../../theme/Component/BasicButton";


export const RetroactiveEmployee = () => {

    const employeeretriactive = useDataBean(_RetroactiveEmployee);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [bonus, setBonus] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        employeeretriactive.instance.getRetroactiveEmployeeCatalog(bonus).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        employeeretriactive.setBean({
            IDEmploymentBonus: employeeretriactive.bean.IDEmploymentBonus
        });
        setModal({ ...modal, "view": true, name: "Agregar RetroActividad" });
    }
    const deleteItem = () => {
        employeeretriactive.deleteItemVoid(employeeretriactive.bean.IDRetroactiveEmployee).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const validarCampos = () => {
        const bean = employeeretriactive.bean;
        let errores = [];

        if (!bean.IDAccount) errores.push("Debe seleccionar un empleado.");
        if (!bean.IDEmploymentBonus) errores.push("Debe seleccionar una prima o bonificación.");
        if (bean.UserOtherDate && !bean.FromDate) errores.push("Debe ingresar la fecha de corte.");
        if (bean.InitialLeft === null || bean.InitialLeft === undefined || bean.InitialLeft === "") errores.push("Debe ingresar el saldo al corte.");

        if (errores.length > 0) {
            errores.forEach(msg => toast.warning(msg));
            return false;
        }

        return true;
    }
    const editaItem = () => {
        if (!validarCampos()) return;

        employeeretriactive.update().then(
            (resp: any) => {
                getLista();
                console.log(resp)
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        });
    }

    const head = [
        { title: 'ID', property: 'IDRetroactiveEmployee', visible: true },
        { title: 'Empleado', property: 'AccountName', visible: true },
        { title: 'Prima Adicional/Bonificación', property: 'EmployeeBonusName', visible: true },
        { title: 'Utilizar Fecha de Corte', property: 'UserOtherDate', visible: true },
        { title: 'Fecha Corte', property: 'FromDate', visible: true, mask: MASK_DATE },
        { title: 'Saldo al Corte', property: 'InitialLeft', visible: true, mask: MASK_MONEY },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar Retroactividad`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Empleados con Retroactividad">
            <div className="row">
                <div className="col-md-4">
                    <EmployeeBonusEditor label="Prima Adicional/Bonificación" idSelector={bonus} onChange={(e) => { setBonus(e) }} />

                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-folder-add-line" eventClick={getLista}>Buscar</BasicButton>
                </div>


                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={employeeretriactive.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                </div>

                <div className="col-md-12">

                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <AccountEditor label="Empleado" idAccount={employeeretriactive.bean.IDAccount} onChange={(e) => { employeeretriactive.setBean({ ...employeeretriactive.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                            </div>
                            <div className="col-md-6">
                                <EmployeeBonusEditor label="Prima Adicional/Bonificación" idSelector={employeeretriactive.bean.IDEmploymentBonus} onChange={(e) => { employeeretriactive.setBean({ ...employeeretriactive.bean, "IDEmploymentBonus": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label='Utilizar Fecha de Corte' estado={employeeretriactive.bean.UserOtherDate} eventChange={(e) => { employeeretriactive.setBean({ ...employeeretriactive.bean, "UserOtherDate": e }) }} />
                            </div>
                            {employeeretriactive.bean.UserOtherDate &&
                                <div className="col-md-6">
                                    <InputDate label="Fecha Corte" name="FromDate" value={employeeretriactive.bean.FromDate} setDate={(e: any) => { employeeretriactive.setBean({ ...employeeretriactive.bean, 'FromDate': e }) }} ></InputDate>
                                </div>
                            }

                            <div className="col-md-6">
                                <InputMoney _value={employeeretriactive.bean.InitialLeft} onChange={(e) => { employeeretriactive.setBean({ ...employeeretriactive.bean, 'InitialLeft': e }) }} _label="Saldo al Corte" />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {employeeretriactive.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}